export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/08ee3b32e72dd5b2b700754671ea2016.svg";